<template>
  <div class="rounded-xl pb-4" id="agenda">
    <h3
      class=" text-6xl lg:text-massive text-darkpurple uppercase text-center font-bebas"
    >
      SCHEDULE
    </h3>
    <div class="flex flex-row px-4 justify-center">
      <div class="cursor-pointer" @click="selectIndex(0)">
        <div
          class="font-bebas text-peach uppercase text-2xl lg:text-4xl leading-none cursor-pointer"
          :class="{ 'border-b-4 border-peach': selectedIndex === 0 }"
        >
          Day 1
        </div>
      </div>
      <div class="ml-2 pl-4  cursor-pointer" @click="selectIndex(1)">
        <div
          class="font-bebas text-darkpurple uppercase text-2xl lg:text-4xl leading-none"
          :class="{ 'border-b-4 border-darkpurple': selectedIndex === 1 }"
        >
          Day 2
        </div>
      </div>
      <div class="ml-2 pl-4  cursor-pointer" @click="selectIndex(2)">
        <div
          class="font-bebas text-green uppercase text-2xl lg:text-4xl leading-none"
                    :class="{ 'border-b-4 border-green': selectedIndex === 2 }"
        >
          Day 3
        </div>
<!--        <div-->
<!--          class="flex flex-row font-bebas uppercase items-top text-green cursor-pointer"-->
<!--        >-->
<!--          <div-->
<!--            class="text-6xl lg:text-massive leading-none"-->
<!--            :class="{ 'border-b-4 border-green': selectedIndex === 2 }"-->
<!--          >-->
<!--            26-->
<!--          </div>-->
<!--          <div class="text-xl">th</div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="mt-10 pl-6">
      <paper-agenda-item
        v-for="session in groupedSessions[selectedSessionKey]"
        :key="session._id"
        :session="session"
      ></paper-agenda-item>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import PaperAgendaItem from "./PaperAgendaItem";

export default {
  name: "PaperAgenda",
  components: { PaperAgendaItem },
  data() {
    return {
      dates: [],
      groupedSessions: {},
      selectedSessionKey: null,
      selectedIndex: 0
    };
  },
  methods: {
    selectIndex(idx) {
      this.selectedIndex = idx;
      this.selectedSessionKey = this.dates[idx];
    },
    setDate(date) {
      this.selectedSessionKey = date;
    },
    fetchSessions() {
      const queryString =
        "*[_type == 'session'] | order(startTime asc) {speakers[]->{name},...}";
      console.log("Querying data");
      sanityClient
        .fetch(queryString)
        .then(res => {
          const sessionDates = [];
          const groups = res.reduce((groups, session) => {
            const date = new Date(session.startTime).toLocaleDateString();
            if (!groups[date]) {
              groups[date] = [];
              sessionDates.push(date);
            }
            groups[date].push(session);
            return groups;
          }, {});

          this.dates = sessionDates;
          this.groupedSessions = groups;
          this.selectIndex(this.selectedIndex);
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  mounted() {
    this.fetchSessions();
  }
};
</script>

<style scoped>
#agenda {
  background-image: url("/images/ScheduleCropped_MQ.png");
}
.text-massive {
  font-size: 66pt;
}
.rounded-xl {
  border-radius: 2rem;
}
.agenda-grid {
  display: grid;
}
</style>
